export const onlyAlphanumeric = (value: string): string => {
  return value.replace(/[^a-zA-Z0-9\s\u00C0-\u017F]/g, '');
};
